export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitFor = async (predicate: () => boolean) => {
  while (!predicate()) {
    // eslint-disable-next-line no-await-in-loop
    await delay(10);
  }
};

/** Firebase Auth UIDs for temporary guest share-link users — not full CQ accounts. */
export function isGuestAuthUid(uid: string): boolean {
  return uid.startsWith('guest_');
}
